import { navigate } from '@reach/router';
import { AppPath } from 'appConstants';
import { Button } from 'components/button/Button';
import i18n from 'i18n/i18n';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeModal } from 'reducers/modal';

type AssessmentNonRecruitmentWarningModalProps = {
  data: {
    continueFunction: () => void;
  };
};

const AssessmentNonRecruitmentWarningModal: React.FC<
  AssessmentNonRecruitmentWarningModalProps
> = ({ data }) => {
  const { t } = useTranslation('Assessment+Non+Recruitment+Warning+Modal', {
    i18n,
  });
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleSeeApplications = () => {
    navigate(AppPath.JOB_APPLICATIONS_LIVE);
    handleCloseModal();
  };

  const handleContinueToTest = () => {
    data.continueFunction();
    handleCloseModal();
  };

  return (
    <div className={`AssessmentModal NonRecruitmentWarning`}>
      <div className="Content">
        <p>{t('SSCandidate_Non_Recruitment_Warning_Modal_Text_01')}</p>
        <p>{t('SSCandidate_Non_Recruitment_Warning_Modal_Text_02')}</p>
      </div>
      <div className="ModalFooter">
        <Button
          className="Rounded"
          priority="tertiary"
          type="button"
          onClick={handleSeeApplications}
        >
          {t('SSCandidate_Non_Recruitment_Warning_Modal_See_Applications')}
        </Button>
        <Button
          className="Discard Rounded"
          priority="primary"
          type="submit"
          onClick={handleContinueToTest}
        >
          {t('SSCandidate_Non_Recruitment_Warning_Modal_Continue')}
        </Button>
      </div>
    </div>
  );
};

export { AssessmentNonRecruitmentWarningModal };
